import { useDataCatalog } from "@/composable/data-catalog";
import { AggregateType, WeatherDataType } from "@soft-db/data-formatter";
import { FieldFactory } from "@soft-db/form";
import { SoftSelect } from "@soft-db/ui";
import { PropType, defineComponent, watch } from "vue";
import * as z from "zod";
import { QueryDataConfigForm } from "./QueryDataConfig";

export default defineComponent({
	name: "SoundDataConfigSettings",

	props: {
		subType: {
			type: String as PropType<WeatherDataType>,
			required: true,
		},
		useField: {
			type: Function as PropType<FieldFactory<QueryDataConfigForm>>,
			required: true,
		},
	},

	setup(props) {
		const { t } = useI18n();
		const data = props.useField("$dataConfig.data", { schema: z.nativeEnum(WeatherDataType) });
		const aggregate = props.useField("$dataConfig.aggregate", {
			schema: z.nativeEnum(AggregateType),
		});

		watch(
			() => props.subType,
			(type) => {
				data.data.value = type;
			},
			{ immediate: true }
		);

		const { generateMenuEntries, WeatherAggregates } = useDataCatalog();

		const aggregates = generateMenuEntries(WeatherAggregates);

		return () => (
			<SoftSelect
				label={t("dashboard.aggregate")}
				items={aggregates}
				itemText="name"
				itemValue="value"
				required
				{...aggregate.attrs}
			/>
		);
	},
});
